import { render } from "./QuoteApprovalModal.vue?vue&type=template&id=40026436&scoped=true"
import script from "./QuoteApprovalModal.vue?vue&type=script&lang=ts"
export * from "./QuoteApprovalModal.vue?vue&type=script&lang=ts"

import "./QuoteApprovalModal.vue?vue&type=style&index=0&id=40026436&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-40026436"

export default script